import {
  CountryEnum,
  DictionariesService,
  DictionaryEnumResponse_CountryEnum,
} from '@acme/api';

class CountryStore {
  private countries: DictionaryEnumResponse_CountryEnum[] | null = null;
  private loadingPromise: Promise<DictionaryEnumResponse_CountryEnum[]> | null =
    null;
  private error: Error | null = null;

  async getCountries(): Promise<DictionaryEnumResponse_CountryEnum[]> {
    if (this.countries) {
      return this.countries;
    }

    if (this.loadingPromise) {
      return this.loadingPromise;
    }

    this.loadingPromise = (async () => {
      try {
        const response =
          await DictionariesService.getApiV1DictionariesCountries();
        if (!response.data) {
          throw new Error('No data received from countries API');
        }
        this.countries = response.data;
        return this.countries;
      } catch (err) {
        this.error =
          err instanceof Error ? err : new Error('Failed to load countries');
        throw this.error;
      } finally {
        this.loadingPromise = null;
      }
    })();

    return this.loadingPromise;
  }

  getCountryById(
    id: CountryEnum
  ): DictionaryEnumResponse_CountryEnum | undefined {
    return this.countries?.find((country) => country.id === id);
  }

  getCountryByCode(
    code: string
  ): DictionaryEnumResponse_CountryEnum | undefined {
    return this.countries?.find((country) => country.name === code);
  }
}

export const countryStore = new CountryStore();
